import * as React from 'react';
import { useUiStore } from '@/store/uiStore';
import { GradientModal } from '@/components/ui/GradientModal';

const FAQ_ITEMS = [
  {
    question: 'What is D.ECHOES?',
    answer:
      'D.ECHOES lets you create a digital version of yourself (an “Echo”) that can talk, answer questions, and engage with people anytime 24/7.',
  },
  {
    question: 'What exactly is an Echo?',
    answer:
      'An Echo is an AI-powered digital presence trained on your knowledge, tone, and personality to hold ongoing conversations that feel authentic to you.',
  },
  {
    question: 'Who can create an Echo?',
    answer:
      'Creators, professionals, athletes, brands, and public figures or anyone who wants to scale conversations without being constantly online.',
  },
  {
    question: 'How is D.ECHOES different from chatbots or character AI?',
    answer:
      'Echoes are based on real people, not fictional characters, and are designed for continuity, accuracy, and long-term engagement - not one-off chats.',
  },
  {
    question: 'What can people do with my Echo?',
    answer:
      'They can ask questions, learn from your experience, get advice, explore your ideas, and keep conversations going even when you’re offline.',
  },
  {
    question: 'Do I control what my Echo says?',
    answer:
      'Yes. You define boundaries, guardrails, and approved knowledge. You can update, refine, or pause your Echo at any time.',
  },
  {
    question: 'Can I monetize my Echo?',
    answer:
      'Yes. Echoes can generate revenue through paid access, premium conversations, subscriptions, or exclusive content.',
  },
  {
    question: 'Is my data safe?',
    answer:
      'Yes. Your data is used only to power your Echo and is protected by strict platform controls and creator-defined permissions.',
  },
  {
    question: 'Why would users come back to an Echo?',
    answer:
      'Echoes remember context, evolve over time, and unlock deeper conversations making each return more valuable than the last.',
  },
  {
    question: 'How do I get started?',
    answer:
      'Join the platform, create your Echo, define its personality and rules, and publish it for the world to engage with.',
  },
];

export const EchoDetailsModal: React.FC = () => {
  const isOpen = useUiStore((state) => state.modals.echoDetails);
  const closeModal = useUiStore((state) => state.closeModal);

  return (
    <GradientModal
      isOpen={isOpen}
      onClose={() => closeModal('echoDetails')}
      variant='purple'
      className='max-w-[728px]'
      hideCloseButton={false}
      contentClassName='!py-[31px] !pr-[20px] !pl-[40px]'
    >
      <div className='flex flex-col items-center pt-0'>
        {/* Header */}
        <div className='mb-8 text-center font-sans text-32 font-bold leading-[40px] text-brand-800'>
          D.ECHOES Details
        </div>

        <div className='w-full space-y-6 pr-2 text-left'>
          {FAQ_ITEMS.map((item, index) => (
            <section key={index}>
              <h4 className='mb-[10px] font-sans text-20 font-medium leading-27 text-dark-100'>
                {index + 1}. {item.question}
              </h4>
              <p className='font-sans text-16 font-normal leading-24 text-gray-600'>
                {item.answer}
              </p>
            </section>
          ))}
        </div>
      </div>
    </GradientModal>
  );
};
